export const PageHeader = ({ title, subtitle, backgroundImage }) => (
  <div className="relative h-[50vh] min-h-[400px] flex items-end" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center" }}>
    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/20" />
    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-20 w-full pb-14">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-12 h-[2px] bg-[#C4A265]" />
        <span className="text-xs uppercase tracking-[0.3em] text-[#C4A265] font-medium">{subtitle}</span>
      </div>
      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white font-light" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{title}</h1>
      <div className="w-24 h-[2px] bg-[#C4A265] mt-6" />
    </div>
    <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-transparent via-[#C4A265] to-transparent z-10" />
  </div>
);
export default PageHeader;